import type { ReactNode } from 'react';

interface CheckboxProps {
    id: string;
    label: ReactNode;
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    className?: string;
}

// Spiris draws the box on the label, so it is mandatory
const Checkbox = ({ id, label, checked, onChange, disabled = false, className = '' }: CheckboxProps) => (
    <div className={`checkbox m-0${disabled ? ' disabled' : ''}${className.length > 0 ? ` ${className}` : ''}`}>
        <input id={id} type="checkbox" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
        <label htmlFor={id}>{label}</label>
    </div>
);

export default Checkbox;
